export default __webpack_public_path__ + "static/media/location.72a18e07.svg";